(ns nosco.oembed
  (:require [clojure.string :as string]))


(def oembed-providers-raw
  [{"provider_name" "YouTube",
    "provider_url" "https://www.youtube.com/",
    "endpoints"
    [{"schemes" ["https://*.youtube.com/watch*",
                 "https://*.youtube.com/v/*",
                 "https://youtu.be/*",
                 "https://*.youtube.com/playlist?list=*"],
      "url" "https://www.youtube.com/oembed",
      "discovery" true}]},
   {"provider_name" "Vimeo",
    "provider_url" "https://vimeo.com/",
    "endpoints"
    [{"schemes" ["https://vimeo.com/*",
                 "https://vimeo.com/album/*/video/*",
                 "https://vimeo.com/channels/*/*",
                 "https://vimeo.com/groups/*/videos/*",
                 "https://vimeo.com/ondemand/*/*",
                 "https://player.vimeo.com/video/*"
                 ],
      "url" "https://vimeo.com/api/oembed.{format}",
      "discovery" true}]},
   {"provider_name" "Microsoft Stream",
    "provider_url" "https://stream.microsoft.com",
    "endpoints"
    [{"schemes" ["https://*.microsoftstream.com/video/*",
                 "https://*.microsoftstream.com/channel/*"],
      "url" "https://web.microsoftstream.com/oembed",
      "discovery" true}]},])

(defn oembed-regex [pattern]
  (re-pattern
    (-> pattern
        (clojure.string/replace "." "\\.")
        (clojure.string/replace "*" "(.+)"))))

(def oembed-providers
  (doall
    (for [provider oembed-providers-raw
          :let [endpoints (get provider "endpoints")]]
      (assoc provider "endpoints"
             (doall
               (for [endpoint endpoints]
                 (-> endpoint
                     (update "url" #(string/replace % "{format}" "json"))
                     (update "schemes" #(map oembed-regex %)))))))))

(defn- url-matches-schemes [link schemes]
  (->> schemes
       (filter #(re-matches % link))
       (seq)))

(defn- oembed-match [link provider]
  (let [endpoints (get provider "endpoints")
        matched-endpoint
        (->> endpoints
             (filter #(url-matches-schemes link (get % "schemes")))
             first)]
    matched-endpoint))

(defn oembed-provider
  "Given a link, return a supported oembed provider, the matched endpoint, and the service url, if any"
  [link]
  (let [provider (->> oembed-providers
                      (filter #(oembed-match link %))
                      first)
        endpoint (oembed-match link provider)
        url (get endpoint "url")]
    {:provider provider
     :endpoint endpoint
     :url url}))


(defn oembed-service-url
  "If a link matches a supported oembed provider, return the url of the oembed service"
  [link]
  (let [{:keys [url]} (oembed-provider link)]
    url))


(comment
  (let [link "https://www.youtube.com/watch?v=qvPv7_HL8GI"]
    [(oembed-provider link)
     (oembed-service-url link)])
  )
